export default "__VITE_ASSET__e3c1ccaf__"